import React from "react";

import styles from "./TwoSectionsImages.module.scss";

function TwoSectionsImages(props) {
  const { children } = props;

  const addClass = (child, key) => {
    let newClassName;
    if (child.props.className) {
      newClassName = `${child.props.className} ${styles.image}`;
    } else {
      newClassName = styles.image;
    }

    const props = {
      className: newClassName,
      key,
    };

    return React.cloneElement(child, props);
  };

  return Array.isArray(children) ? (
    <div className={styles.container}>
      {children.map((child, index) => addClass(child, index))}
    </div>
  ) : null;
}

export default TwoSectionsImages;
